import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

// دالة لحساب الاتجاه (البوصلة) من موقع المستخدم إلى مكة المكرمة
const calculateKiblaDirection = (lat, lng) => {
  const kiblaLat = 21.4225; // دائرة العرض للكعبة، مكة
  const kiblaLng = 39.8262; // خط الطول للكعبة، مكة

  const radianConversion = Math.PI / 180;
  const lat1 = lat * radianConversion;
  const lon1 = lng * radianConversion;
  const lat2 = kiblaLat * radianConversion;
  const lon2 = kiblaLng * radianConversion;

  const deltaLon = lon2 - lon1;

  const y = Math.sin(deltaLon) * Math.cos(lat2);
  const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(deltaLon);

  const initialBearing = Math.atan2(y, x);
  const bearing = (initialBearing * 180) / Math.PI;

  return (bearing + 360) % 360; // التأكد من أنه قيمة موجبة
};

const KiblaCompassPage = () => {
  const [userLocation, setUserLocation] = useState(null);
  const [compassAngle, setCompassAngle] = useState(0);  // اتجاه القبلة
  const [deviceHeading, setDeviceHeading] = useState(0); // اتجاه البوصلة المغناطيسية للجهاز

  // الحصول على موقع المستخدم باستخدام واجهة geolocation
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setUserLocation({ latitude, longitude });
        },
        (error) => {
          console.error(error);
          alert('لم نتمكن من الحصول على موقعك');
        }
      );
    }
  }, []);

  // الاستماع إلى أحداث التوجيه للجهاز للحصول على الاتجاه
  useEffect(() => {
    const handleOrientation = (event) => {
      const { alpha } = event; // قيمة alpha تشير إلى الاتجاه بالدرجات
      setDeviceHeading(alpha); // تعيين اتجاه الجهاز (الشمال المغناطيسي)
    };

    if (window.DeviceOrientationEvent) {
      window.addEventListener('deviceorientation', handleOrientation);
    }

    return () => {
      window.removeEventListener('deviceorientation', handleOrientation);
    };
  }, []);

  // تحديث زاوية البوصلة عندما يتغير الموقع أو اتجاه الجهاز
  useEffect(() => {
    if (userLocation) {
      const angleToKibla = calculateKiblaDirection(userLocation.latitude, userLocation.longitude);
      const adjustedAngle = (angleToKibla - deviceHeading + 360) % 360; // التعديل بناءً على اتجاه الجهاز
      setCompassAngle(adjustedAngle);
    }
  }, [userLocation, deviceHeading]);

  return (
    <div className="container mx-auto p-6 flex flex-col items-center justify-center">
      <h1 className="text-4xl font-bold text-center mb-6 text-green-700">
        بوصلة القبلة
      </h1>
      <div className="text-center mb-6">
        {userLocation ? (
          <p>
            موقعك: {userLocation.latitude.toFixed(2)}, {userLocation.longitude.toFixed(2)}
          </p>
        ) : (
          <p>جارٍ الحصول على موقعك...</p>
        )}
      </div>

      {/* واجهة بوصلة القبلة */}
      <div className="relative w-72 h-72 border-4 border-green-700 rounded-full mb-6 flex justify-center items-center bg-white">
        {/* وردة البوصلة */}
        <div className="absolute w-72 h-72 rounded-full border border-green-700 flex justify-center items-center">
          <div className="absolute top-2 left-2 w-full h-full">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 text-xs font-bold text-gray-700">شمال</div>
            <div className="absolute right-0 top-1/2 transform -translate-y-1/2 text-xs font-bold text-gray-700">شرق</div>
            <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 text-xs font-bold text-gray-700">جنوب</div>
            <div className="absolute left-0 top-1/2 transform -translate-y-1/2 text-xs font-bold text-gray-700">غرب</div>
          </div>
        </div>

        {/* إبرة البوصلة المتحركة */}
        <motion.div
          className="absolute w-1/2 h-1/2 bg-red-600 rounded-full"
          style={{
            transform: `rotate(${compassAngle}deg)`,
          }}
          animate={{
            rotate: compassAngle,
          }}
          transition={{
            type: 'spring',
            stiffness: 200,
            damping: 20,
          }}
        >
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-1/2 h-1/2 bg-red-600"></div>
        </motion.div>
      </div>
      <div className="text-center">
        <p>
          تشير البوصلة نحو الكعبة في مكة المكرمة (القبلة) بناءً على موقعك الحالي واتجاه جهازك.
        </p>
      </div>
    </div>
  );
};

export default KiblaCompassPage;
